/* Fiche livre : variantes, quantité, galerie, « Lire la suite », détails, barre d'achat fixe mobile, appel final.
   Maquette : js/livre.js (initBar, gestionnaires « Lire la suite » et détails) ; l'ajout au panier est dans mi-cart.js.
   Marqueurs : [data-mi-product-form], [data-mi-variants] (JSON), [data-mi-variant-id], [data-mi-option], [data-mi-qty], [data-mi-buybar], [data-mi-more],
   [data-mi-specs], [data-mi-thumb], [data-mi-final-add], #mi-buy-main. Tout est idempotent (rechargement de section dans l'éditeur de thème). */
import { $, $$, on } from 'mi/dom';

const MI = window.MI || {};
const MAX = Number((MI.cart || {}).maxQty) || 10;
const money = (cents) => new Intl.NumberFormat(MI.locale || 'fr', { style: 'currency', currency: (MI.cart || {}).currency || 'EUR' }).format(cents / 100);

function initForm(form) {
  if (form.dataset.miInit) return; form.dataset.miInit = '1';
  const data = $('[data-mi-variants]', form); if (!data) return;
  let variants = []; try { variants = JSON.parse(data.textContent); } catch (e) { return; }
  const idInput = $('[data-mi-variant-id]', form);
  const addBtn = $('[data-mi-add]', form); const label = $('[data-mi-add-label]', form);
  const scope = form.closest('[data-mi-pdp]') || document;

  const selected = () => $$('[data-mi-option]', form).map((fs) => { const c = $('input:checked', fs); return c ? c.value : null; });
  const sync = () => {
    const picks = selected(); if (!picks.length) return;
    const v = variants.find((x) => picks.every((val, i) => val === null || x['option' + (i + 1)] === val));
    if (!v) return;
    idInput.value = v.id;
    const url = new URL(window.location.href); url.searchParams.set('variant', v.id); window.history.replaceState({}, '', url);
    if (addBtn) { addBtn.disabled = !v.available; addBtn.toggleAttribute('aria-disabled', !v.available); }
    if (label) label.textContent = v.available ? (label.dataset.addText || (MI.i18n || {}).addToCart) : (MI.i18n || {}).soldOut;
    $$('[data-mi-price] .price__now', document).forEach((el) => { el.textContent = money(v.price); });
    $$('[data-mi-price] .price__was', document).forEach((el) => { el.hidden = !(v.compare_at_price > v.price); });
    $$('[data-mi-buybar-add]').forEach((b) => { if (!b.dataset.done) { b.disabled = !v.available; if (v.available) b.textContent = b.dataset.addText || (MI.i18n || {}).addToCart || b.textContent; else b.textContent = (MI.i18n || {}).soldOut || b.textContent; } });
    $$('[data-mi-final-add]').forEach((b) => { b.dataset.addToCart = v.id; b.disabled = !v.available; });
  };
  $$('[data-mi-option] input', form).forEach((i) => on(i, 'change', sync));

  const qty = $('[data-mi-qty]', form);
  if (qty) {
    const clamp = () => { qty.value = Math.max(1, Math.min(MAX, Number(qty.value) || 1)); };
    on(qty, 'change', clamp);
    const dec = $('[data-mi-qty-dec]', form); const inc = $('[data-mi-qty-inc]', form);
    if (dec) on(dec, 'click', () => { qty.value = Number(qty.value) - 1; clamp(); });
    if (inc) on(inc, 'click', () => { qty.value = Number(qty.value) + 1; clamp(); });
  }
}

/* Galerie : une vignette remplace l'image principale (même balise, pas de saut de mise en page : width/height de la vignette) */
function initGallery(box) {
  if (box.dataset.miInit) return; box.dataset.miInit = '1';
  const main = $('.lv-cover, .bq-gal__img', box); if (!main || main.tagName !== 'IMG') return;
  $$('[data-mi-thumb]', box).forEach((btn) => on(btn, 'click', () => {
    main.removeAttribute('srcset'); main.removeAttribute('sizes');
    main.src = btn.dataset.src; main.width = Number(btn.dataset.width) || main.width; main.height = Number(btn.dataset.height) || main.height;
    $$('[data-mi-thumb]', box).forEach((b) => { const cur = b === btn; b.classList.toggle('is-current', cur); b.setAttribute('aria-pressed', String(cur)); });
  }));
}

/* « Lire la suite » : ne déplie que la suite ; le bouton reste SOUS le texte déplié et change de libellé (leçon 28) */
function initMore(btn) {
  if (btn.dataset.miInit) return; btn.dataset.miInit = '1';
  on(btn, 'click', () => {
    const open = btn.getAttribute('aria-expanded') !== 'true';
    btn.setAttribute('aria-expanded', String(open));
    btn.textContent = open ? btn.dataset.lessLabel : btn.dataset.moreLabel;
    const box = document.getElementById(btn.getAttribute('aria-controls'));
    if (box) { box.classList.toggle('is-open', open); box.setAttribute('aria-hidden', String(!open)); box.toggleAttribute('inert', !open); }
  });
}

/* Détails : toujours ouverts sur ordinateur, accordéon sur mobile */
function initSpecs(box) {
  if (box.dataset.miInit) return; box.dataset.miInit = '1';
  const mq = window.matchMedia('(min-width: 900px)');
  const sync = () => { box.open = mq.matches; };
  sync(); mq.addEventListener('change', sync);
  const summary = $('summary', box);
  if (summary) on(summary, 'click', (e) => { if (mq.matches) e.preventDefault(); });
}

/* Barre d'achat fixe : visible quand le bouton principal a quitté l'écran (par le haut), masquée près de l'appel final, de la newsletter et du pied
   (jamais de contenu caché derrière). Après un premier ajout, le bouton devient « Voir le panier » et ouvre le tiroir. */
function initBuyBar() {
  const bar = $('[data-mi-buybar]'); const main = $('#mi-buy-main [data-mi-add]');
  if (!bar || !main || bar.dataset.miInit || !('IntersectionObserver' in window)) return;
  bar.dataset.miInit = '1';
  const state = { away: false, end: false };
  const apply = () => { const show = state.away && !state.end; bar.classList.toggle('is-on', show); bar.toggleAttribute('inert', !show); };
  new IntersectionObserver(([e]) => { state.away = !e.isIntersecting && e.boundingClientRect.top < 0; apply(); }).observe(main);
  const ends = $$('[data-mi-final], #newsletter, .mi-newsletter, footer.site-footer');
  if (ends.length) {
    const hit = new Set();
    const io = new IntersectionObserver((es) => { es.forEach((e) => (e.isIntersecting ? hit.add(e.target) : hit.delete(e.target))); state.end = hit.size > 0; apply(); });
    ends.forEach((el) => io.observe(el));
  }
  const btn = $('[data-mi-buybar-add]', bar);
  if (btn) on(btn, 'click', (e) => {
    if (btn.dataset.done) { e.preventDefault(); e.stopImmediatePropagation(); document.dispatchEvent(new CustomEvent('mi:cart-open')); return; }
    btn.dataset.done = '1'; if (btn.dataset.doneLabel) btn.textContent = btn.dataset.doneLabel;
  }, true);
  apply();
}

function boot() {
  $$('[data-mi-product-form]').forEach(initForm);
  $$('[data-mi-gallery]').forEach(initGallery);
  $$('[data-mi-more]').forEach(initMore);
  $$('[data-mi-specs]').forEach(initSpecs);
  initBuyBar();
}
boot();
document.addEventListener('shopify:section:load', boot);
